module.exports = __webpack_public_path__ + "static/img/Cooper-Bell.89b13af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cooper-Bell.jpg
// module id = y46i
// module chunks = 0